import { useLoadingStore } from '@/modules/core/stores/loadingStore'
import { raterGuard } from './guards'
import type { RouteLocationNormalized, NavigationGuardNext, RouteRecordRaw } from 'vue-router'
import { useDentalStore as useDentalRaterStore } from '@/modules/dental/rater/stores'
import { useDentalStore } from '@/modules/dental/hiring/stores'
import ModifyInsuranceModal from '@/modules/dental/rater/views/modals/ModifyInsuranceModal.vue'
import BranchEnum from '@/modules/core/models/BranchEnum'
import DentalInsuranceProcessStepEnum from '@/modules/dental/hiring/models/APP/DentalInsuranceProcessStepEnum'

const RATER_TITLE = 'Precios y Tarifas de los Seguros Dentales | ASISA'
const RATER_DESCRIPTION =
  'Encuentra el precio de tu seguro dental ASISA y compara las tarifas fácilmente para elegir la mejor para ti.'

export const DENTAL_RATER_ROUTES = [
  {
    path: 'dental',
    name: 'rater-dental',
    component: () => import('../modules/common/rater/views/BaseView.vue'),
    meta: {
      title: RATER_TITLE,
      description: RATER_DESCRIPTION,
      branchName: BranchEnum.DENTAL,
      defaultBusinessLineId: 'AS00'
    },
    props: () => ({
      store: useDentalRaterStore()
    }),
    beforeEnter: async (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      useLoadingStore().startLoading('common.loading.processing-almost-got-it')
      await raterGuard(to, from, next)
    }
  },
  {
    path: 'dental/:productCode/:clientCode',
    name: 'dental-product',
    component: () => import('../modules/common/rater/views/ProductBaseView.vue'),
    meta: {
      title: RATER_TITLE,
      description: RATER_DESCRIPTION,
      branchName: BranchEnum.DENTAL
    },
    props: () => ({
      store: useDentalRaterStore(),
      modifyModal: ModifyInsuranceModal
    }),
    beforeEnter: async (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      useLoadingStore().startLoading('common.loading.processing')
      await raterGuard(to, from, next)
    }
  },
  {
    path: 'dental/propuestas',
    name: 'dental-insurance-proposals',
    component: () => import('@/modules/common/rater/views/ProductProposalsView.vue'),
    meta: {
      title: RATER_TITLE,
      description: RATER_DESCRIPTION,
      branchName: BranchEnum.DENTAL
    },
    props: () => ({
      store: useDentalRaterStore(),
      modifyModal: ModifyInsuranceModal
    }),
    beforeEnter: async (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      useLoadingStore().startLoading('common.loading.processing')
      await raterGuard(to, from, next)
    }
  }
] as RouteRecordRaw[]

export const DENTAL_HIRING_ROUTES = [
  {
    path: 'dental/:id',
    name: 'hiring-dental',
    component: () => import('../modules/dental/hiring/views/BaseView.vue'),
    meta: {
      title: 'Seguros Médicos ASISA',
      branchName: BranchEnum.DENTAL
    },
    beforeEnter: (
      to: RouteLocationNormalized,
      from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      useLoadingStore().startLoading('common.loading.processing', 'common.loading.starting-hiring')
      raterGuard(to, from, next)
    }
  },
  {
    path: 'dental/firma/:hash',
    name: 'dental-hiring-signature',
    component: () => import('../modules/common/hiring/views/SignatureView.vue'),
    meta: {
      title: 'Seguros Médicos ASISA',
      branchName: BranchEnum.DENTAL
    },
    props: {
      branchName: BranchEnum.DENTAL,
      stepCode: DentalInsuranceProcessStepEnum.SIGN
    },
    beforeEnter: () => {
      useLoadingStore().startLoading('common.loading.processing')
    }
  },
  {
    path: 'dental/firma-completada/:hash',
    name: 'dental-hiring-signature-done',
    meta: {
      title: 'Seguros Médicos ASISA',
      branchName: BranchEnum.DENTAL
    },
    beforeEnter: () => {
      const loadingStore = useLoadingStore()
      loadingStore.stopLoading()
      loadingStore.startLoading('common.loading.processing')
    },
    component: () => import('../modules/common/hiring/views/SignatureCompleteView.vue'),
    props: {
      async emissionServiceCallback(quotationId: string) {
        return await useDentalStore().emission(quotationId)
      },
      branchName: BranchEnum.DENTAL
    }
  }
] as RouteRecordRaw[]
